import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { Box, Button, Dialog, Pagination, useMediaQuery } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";

import Layout from "../../shared/Layout";
import FastBreadcrumbs from "../../shared/FastBreadcrumbs";
import Filter from "./components/Filter/Filter";
import { courseService } from "../../services/course.service";
import CardCourse from "../../shared/CardCourse";
import "./search.scss";
import { Language, Level } from "../../types";
import EmptySearch from "./components/EmptySearch/EmptySearch";
import { useParams, useSearchParams } from "react-router-dom";
import useCategory from "../../hooks/useCategory";

import filterIcon from "../../assets/icons/filter.svg";

const Search = () => {
  const isMobile = useMediaQuery("(max-width:1000px)");
  const links = [
    { name: "Главная", link: "/" },
    { name: "Результаты поиска", link: "/search" },
  ];
  const [isMobileFilter, setIsMobileFilter] = useState(false);
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [total, setTotal] = useState(0);
  const { search } = useLocation();
  const { categoryId } = useParams();
  const [lang, setLang] = useState<Language[]>([]);
  const [level, setLevel] = useState<Level[]>([]);
  const [queryParams] = useSearchParams();
  const searchValue = queryParams.get("searchValue");

  const sortData = [
    { name: "Наименование от А до Я", id: "NAME_ASCENDING" },
    { name: "Наименование от Я до А", id: "NAME_DESCENDING" },
  ];
  const [filter, setFilter] = useState<any>({
    category_id: [categoryId],
    language_id: [],
    teacher_id: [],
    search: [decodeURI(searchValue || "")],
    order_by: [],
    level_id: [],
    price: [],
    limit: [12],
    page: [0],
  });
  const { categories } = useCategory();

  useEffect(() => {
    setLoading(true);
    courseService
      .getCourseLanguages()
      .then((data) => setLang(data))
      .catch((e) => console.log(e));
    courseService
      .getCourseLevels()
      .then((data) => setLevel(data))
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    setFilter({
      category_id: [categoryId],
      language_id: [],
      teacher_id: [],
      search: [searchValue],
      order_by: [],
      level_id: [],
      price: [],
      limit: [12],
      page: [0],
    });
  }, [search, categoryId, searchValue]);

  useEffect(() => {
    setLoading(true);
    let query = "";
    for (const [key, value] of Object.entries(filter)) {
      let part = "";
      // @ts-ignore
      value.forEach((el: any) => {
        if (el) {
          part = part + key + "=" + el + "&";
        }
      });
      query = query + part;
    }
    courseService.getCoursesList(query).then((data) => {
      setCourses(data.data.items);
      setTotal(data.data.total);
      setLoading(false);
    });
  }, [filter]);

  const handleChangeOrder = (event: SelectChangeEvent) => {
    setFilter({ ...filter, order_by: [event] });
  };

  const handleChangePage = (_: any, number: number) => {
    if (Math.abs(123 - (number - 1) * 12) < 12) {
      setFilter({
        ...filter,
        page: [number - 1],
        limit: [Math.abs(123 - (number - 1) * 12)],
      });
    } else {
      setFilter({ ...filter, page: [number - 1], limit: [12] });
    }
  };

  const Content = ({}) => {
    if (loading) {
      return (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            margin: "186px auto",
          }}>
          <CircularProgress />
        </Box>
      );
    } else {
      if (!total) {
        return <EmptySearch searchText={filter.search[0]} />;
      }
      return (
        <>
          <Box sx={{ width: "100%" }}>
            {isMobile && (
              <Button
                sx={{
                  width: "145px",
                  height: "32px",
                  border: "1px solid rgba(1, 18, 36, 0.12)",
                  marginBottom: "12px",
                  borderRadius: "8px",
                  textTransform: "unset",
                }}
                onClick={() => setIsMobileFilter(true)}
                color="primary">
                <img
                  src={filterIcon}
                  alt="filter-icon"
                  style={{
                    marginRight: "10px",
                  }}
                />
                Фильтровать
              </Button>
            )}

            <Box>
              <FormControl>
                <InputLabel sx={{ top: "-5px" }}>Сортировать по:</InputLabel>
                <Select
                  className={"search-order"}
                  value={filter.order_by[0]}
                  label="Сортировать по:"
                  onChange={(e) => handleChangeOrder(e.target.value)}>
                  {sortData.map((el) => (
                    <MenuItem value={el.id} key={el.id}>
                      {el.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box className={"studying-cards"}>
              {courses?.map((el: any) => {
                return <CardCourse key={el?.id} info={el} />;
              })}
            </Box>

            {loading ? null : (
              <Box className={"pagination-wrapper"}>
                <Pagination
                  count={Math.ceil(total / 12)}
                  page={+filter.page + 1}
                  shape="rounded"
                  onChange={handleChangePage}
                />
              </Box>
            )}
          </Box>
        </>
      );
    }
  };

  return (
    <Layout>
      <Dialog
        open={isMobileFilter}
        onClose={() => setIsMobileFilter(false)}
        scroll="body"
        PaperProps={{
          sx: {
            width: "90%",
            borderRadius: "8px",
          },
        }}>
        <Filter
          categories={categories}
          filter={filter}
          setFilter={setFilter}
          lang={lang}
          level={level}
          setIsMobileFilter={setIsMobileFilter}
        />
      </Dialog>

      <FastBreadcrumbs links={links} />
      <Box className={"search-total-number"}>{total} результатов поиска</Box>
      <Box className={"search-content-wrapper"}>
        {!isMobile && (
          <Filter
            categories={categories}
            filter={filter}
            setFilter={setFilter}
            lang={lang}
            level={level}
          />
        )}
        <Content />
      </Box>
    </Layout>
  );
};
export default Search;
